import { useState } from 'react'
import FormsyInput from 'shared/components/Textfield/withFormsy'

const PasswordField = ({
    className,
    translate: t,
    validations,
    validationErrors,
    touched,
    autoComplete = 'current-password',
}) => {
    const [passwordVisible, setPasswordVisible] = useState(false)

    const onTogglePasswordHandler = () => setPasswordVisible(!passwordVisible)

    return (
        <FormsyInput
            id="password"
            name="password"
            title={t('auth.password.label')}
            type={passwordVisible ? 'text' : 'password'}
            label={t('auth.password.label')}
            iconRight={'show-hide'}
            className={className}
            onRightIconClickHandler={onTogglePasswordHandler}
            validations={validations}
            validationErrors={validationErrors}
            touched={touched}
            autoComplete={autoComplete}
            required
        />
    )
}

export default compose(withTranslate)(PasswordField)
